<template>
  <div class="share-settings">
    <div class="mention">
      <i class="el-icon-warning" />通过工作手机分享出去的营销素材，分享时会带有一个角标；你可以选择想要的名称和图标icon
    </div>
    <div class="main-state">
      <div class="setting-card">
        <div class="top">
          <div class="info">
            <div class="title">
              这是您分享出去的文章标题
            </div>
            <div class="pic">
              <img
                src="@assets/images/share-settings-pic.png"
                alt="error"
                class="img"
              />
            </div>
          </div>
          <div class="view">
            点击查看
          </div>
        </div>
        <div class="bottom">
          <img
            v-if="settingData.icon"
            :src="settingData.icon"
            alt="error"
            class="img-icon"
          >
          <div class="desc">
            {{ settingData.name }}
          </div>
        </div>
      </div>
      <mk-popover
        v-model="popoverVisible"
        placement="bottom"
        width="160"
        trigger="click"
        popper-class="share-settings-list-popover"
      >
        <div
          slot="reference"
          class="button"
        >
          重新选择角标
        </div>
        <div class="select-list">
          <div
            v-for="item in settingList"
            :key="item._id"
            class="item"
            @click="handleChangeSetting(item)"
          >
            <img
              v-if="item.icon"
              :src="item.icon"
              alt="error"
              class="item-img-icon"
            >
            <div class="item-desc">
              {{ item.name }}
            </div>
          </div>
        </div>
      </mk-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareSettings',
  data () {
    return {
      settingList: [],
      settingData: {},
      popoverVisible: false
    }
  },
  created () {
    this.v1SettingShareIconGet()
    this.v1SettingShareIconListGet()
  },
  methods: {
    // 查询当前公司的分享设置
    async v1SettingShareIconGet () {
      const { success, data } = await ACCOUNTAPIS.SettingApi.v1SettingShareIconGet()
      if (success) {
        this.settingData = data
      }
    },
    // 查询当前公司的分享设置列表
    async v1SettingShareIconListGet () {
      const { success, data } = await ACCOUNTAPIS.SettingApi.v1SettingShareIconListGet()
      if (success) {
        this.settingList = data
      }
    },
    // 设置当前公司的分享图标
    async v1SettingShareIconPut (params) {
      const { success, data } = await ACCOUNTAPIS.SettingApi.v1SettingShareIconPut(params)
      if (success) {
        this.$message.success('设置成功')
        this.v1SettingShareIconGet()
      } else {
        this.$message.error('设置失败')
      }
    },
    // 改变设置
    handleChangeSetting (itemData) {
      this.popoverVisible = false
      this.v1SettingShareIconPut({ appId: itemData.appId })
    }
  }
}
</script>

<style lang="scss" scoped>
.share-settings {
  padding: 16px 20px;

  .mention {
    padding-left: 18px;
    height: 36px;
    display: flex;
    align-items: center;
    color: #262626;
    font-size: 13px;
    line-height: 18px;
    background-color: #f2fbff;
    border: 1px solid #ccecff;

    .el-icon-warning {
      color: #1b9aee;
      margin-right: 8px;
      font-size: 16px;
    }
  }

  .main-state {
    margin-top: 16px;
    display: flex;
    align-items: flex-end;
  }

  .setting-card {
    padding: 10px 0 0 10px;
    width: 240px;
    box-sizing: border-box;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);

    .top {
      border-bottom: 1px solid #f0f0f0;
      padding: 10px;

      .info {
        display: flex;

        .title {
          font-size: 13px;
          color: #262626;
          line-height: 20px;
        }

        .pic {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          overflow: hidden;
          margin: 0 10px;
          flex-shrink: 0;

          .img {
            width: 100%;
            height: 1005;
          }
        }
      }

      .view {
        margin-top: 8px;
        font-size: 12px;
        color: #888;
      }
    }

    .bottom {
      padding-right: 10px;
      height: 32px;
      display: flex;
      align-items: center;
      overflow: hidden;

      .img-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }

      .desc {
        margin-left: 9px;
        color: #888;
        font-size: 12px;
        line-height: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .button {
    margin-left: 20px;
    color: #009cff;
    font-size: 13px;
    line-height: 18px;
    cursor: pointer;
  }
}

.select-list {
  .item {
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    overflow: hidden;
    cursor: pointer;

    .item-img-icon {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
    }

    .item-desc {
      margin-left: 9px;
      color: #666;
      font-size: 13px;
      line-height: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &:hover {
      background-color: #f6f7fa;
    }
  }
}
</style>

<style lang="scss">
.share-settings-list-popover {
  padding: 5px 0;
}
</style>
